export default __webpack_public_path__ + "static/media/part-search.889bed94.svg";